// extracted by mini-css-extract-plugin
export var avatar = "_p7-3";
export var avatarContainer = "_p7-2";
export var avatarSpacer = "_p7-5";
export var avatarSpacerContainer = "_p7-4";
export var avatarStackContainer = "_p7-1";
export var bubble = "_p7-0";
export var remainderBubble = "_p7-6";